// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.3_webpack@5.105.2_esbuild@0.28.1_postcss@8.5.23_/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.3_webpack@5.105.2_esbuild@0.28.1_postcss@8.5.23_/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Work+Sans:wght@500;600&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reconcile-overlay {
  position: fixed;
  inset: 0;
  display: grid;
  place-items: center;
  padding: 16px;
  background: rgba(17, 24, 39, 0.55);
  -webkit-backdrop-filter: blur(2px);
          backdrop-filter: blur(2px);
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: opacity 0.25s ease-in-out, visibility 0.25s ease-in-out;
  z-index: 10000;
}

.reconcile-overlay.visible {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
}

.reconcile-shell {
  width: min(720px, 100%);
}

.reconcile-card {
  position: relative;
  background: #ffffff;
  color: var(--e-global-color-text);
  border-radius: 16px;
  border: 1px solid #e3e7ef;
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.14);
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 18px;
  overflow: hidden;
}

.reconcile-card::before {
  content: "";
  position: absolute;
  inset: -30% auto auto -30%;
  width: 60%;
  height: 60%;
  background: radial-gradient(circle at center, rgba(107, 64, 146, 0.12) 0%, rgba(244, 158, 85, 0.08) 50%, transparent 70%);
  opacity: 0.6;
  pointer-events: none;
}

.close-btn {
  position: absolute;
  top: 14px;
  right: 14px;
  width: 36px;
  height: 36px;
  display: grid;
  place-items: center;
  border-radius: 12px;
  border: 1px solid #e3e7ef;
  background: #f8f9fb;
  color: var(--e-global-color-primary);
  line-height: 1;
  padding: 0;
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.06);
}

.close-btn:hover {
  background: #f1f3f8;
}

.card-header {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 12px;
  align-items: center;
  padding: 12px 14px;
  border: 1px solid #e3e7ef;
  border-radius: 12px;
  background: linear-gradient(135deg, rgba(107, 64, 146, 0.1) 0%, #f8f9fb 100%);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.75);
}

.header-text {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.header-icon {
  width: 56px;
  height: 56px;
  border-radius: 14px;
  background: linear-gradient(145deg, rgba(107, 64, 146, 0.16), rgba(244, 158, 85, 0.16));
  color: var(--e-global-color-primary);
  display: grid;
  place-items: center;
  box-shadow: 0 8px 18px rgba(107, 64, 146, 0.12);
}

.eyebrow {
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-size: 12px;
  color: #6c757d;
}

.card-title {
  margin: 0;
  font-size: 24px;
  font-family: "Work Sans", Arial, sans-serif;
}

.subtitle {
  margin: 0;
  color: #4a5568;
}

.info-panel {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 12px;
  align-items: start;
  background: linear-gradient(135deg, rgba(107, 64, 146, 0.08) 0%, rgba(244, 158, 85, 0.08) 100%);
  border: 1px solid rgba(107, 64, 146, 0.18);
  border-radius: 12px;
  padding: 12px 14px;
  box-shadow: 0 10px 26px rgba(0, 0, 0, 0.08);
}

.info-icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: #ffffff;
  color: var(--e-global-color-primary);
  display: grid;
  place-items: center;
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.08);
}

.info-title {
  font-weight: 700;
  margin: 0 0 4px;
}

.info-copy {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.info-list {
  margin: 0;
  padding-left: 18px;
  color: #1f2937;
  display: grid;
  gap: 4px;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
  position: relative;
  z-index: 1;
}

.action-row {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 6px;
}

@media (max-width: 768px) {
  .reconcile-card {
    padding: 18px;
  }
  .card-title {
    font-size: 22px;
  }
  .info-panel {
    grid-template-columns: 1fr;
  }
  .form-grid {
    grid-template-columns: 1fr;
  }
}`, "",{"version":3,"sources":["webpack://./projects/public/src/app/components/data-reconciliation/data-reconciliation.component.scss"],"names":[],"mappings":"AAEA;EACE,eAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,kCAAA;EACA,kCAAA;UAAA,0BAAA;EACA,UAAA;EACA,kBAAA;EACA,oBAAA;EACA,mEAAA;EACA,cAAA;AAAF;;AAGA;EACE,UAAA;EACA,mBAAA;EACA,oBAAA;AAAF;;AAGA;EACE,uBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,mBAAA;EACA,iCAAA;EACA,mBAAA;EACA,yBAAA;EACA,2CAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;AAAF;;AAGA;EACE,WAAA;EACA,kBAAA;EACA,0BAAA;EACA,UAAA;EACA,WAAA;EACA,yHAAA;EACA,YAAA;EACA,oBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,oCAAA;EACA,cAAA;EACA,UAAA;EACA,0CAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,aAAA;EACA,+BAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,6EAAA;EACA,mDAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAAF;;AAGA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uFAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,+CAAA;AAAF;;AAGA;EACE,SAAA;EACA,yBAAA;EACA,sBAAA;EACA,eAAA;EACA,cAAA;AAAF;;AAGA;EACE,SAAA;EACA,eAAA;EACA,2CAAA;AAAF;;AAGA;EACE,SAAA;EACA,cAAA;AAAF;;AAGA;EACE,aAAA;EACA,+BAAA;EACA,SAAA;EACA,kBAAA;EACA,+FAAA;EACA,0CAAA;EACA,mBAAA;EACA,kBAAA;EACA,2CAAA;AAAF;;AAGA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,0CAAA;AAAF;;AAGA;EACE,gBAAA;EACA,eAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAAF;;AAGA;EACE,SAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;EACA,QAAA;AAAF;;AAGA;EACE,aAAA;EACA,gDAAA;EACA,SAAA;EACA,kBAAA;EACA,UAAA;AAAF;;AAGA;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,eAAA;AAAF;;AAGA;EACE;IACE,aAAA;EAAF;EAGA;IACE,eAAA;EADF;EAIA;IACE,0BAAA;EAFF;EAKA;IACE,0BAAA;EAHF;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Work+Sans:wght@500;600&display=swap');\n\n.reconcile-overlay {\n  position: fixed;\n  inset: 0;\n  display: grid;\n  place-items: center;\n  padding: 16px;\n  background: rgba(17, 24, 39, 0.55);\n  backdrop-filter: blur(2px);\n  opacity: 0;\n  visibility: hidden;\n  pointer-events: none;\n  transition: opacity 0.25s ease-in-out, visibility 0.25s ease-in-out;\n  z-index: 10000;\n}\n\n.reconcile-overlay.visible {\n  opacity: 1;\n  visibility: visible;\n  pointer-events: auto;\n}\n\n.reconcile-shell {\n  width: min(720px, 100%);\n}\n\n.reconcile-card {\n  position: relative;\n  background: #ffffff;\n  color: var(--e-global-color-text);\n  border-radius: 16px;\n  border: 1px solid #e3e7ef;\n  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.14);\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n  overflow: hidden;\n}\n\n.reconcile-card::before {\n  content: '';\n  position: absolute;\n  inset: -30% auto auto -30%;\n  width: 60%;\n  height: 60%;\n  background: radial-gradient(circle at center, rgba(107, 64, 146, 0.12) 0%, rgba(244, 158, 85, 0.08) 50%, transparent 70%);\n  opacity: 0.6;\n  pointer-events: none;\n}\n\n.close-btn {\n  position: absolute;\n  top: 14px;\n  right: 14px;\n  width: 36px;\n  height: 36px;\n  display: grid;\n  place-items: center;\n  border-radius: 12px;\n  border: 1px solid #e3e7ef;\n  background: #f8f9fb;\n  color: var(--e-global-color-primary);\n  line-height: 1;\n  padding: 0;\n  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.06);\n}\n\n.close-btn:hover {\n  background: #f1f3f8;\n}\n\n.card-header {\n  display: grid;\n  grid-template-columns: auto 1fr;\n  gap: 12px;\n  align-items: center;\n  padding: 12px 14px;\n  border: 1px solid #e3e7ef;\n  border-radius: 12px;\n  background: linear-gradient(135deg, rgba(107, 64, 146, 0.1) 0%, #f8f9fb 100%);\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.75);\n}\n\n.header-text {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.header-icon {\n  width: 56px;\n  height: 56px;\n  border-radius: 14px;\n  background: linear-gradient(145deg, rgba(107, 64, 146, 0.16), rgba(244, 158, 85, 0.16));\n  color: var(--e-global-color-primary);\n  display: grid;\n  place-items: center;\n  box-shadow: 0 8px 18px rgba(107, 64, 146, 0.12);\n}\n\n.eyebrow {\n  margin: 0;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  font-size: 12px;\n  color: #6c757d;\n}\n\n.card-title {\n  margin: 0;\n  font-size: 24px;\n  font-family: 'Work Sans', Arial, sans-serif;\n}\n\n.subtitle {\n  margin: 0;\n  color: #4a5568;\n}\n\n.info-panel {\n  display: grid;\n  grid-template-columns: auto 1fr;\n  gap: 12px;\n  align-items: start;\n  background: linear-gradient(135deg, rgba(107, 64, 146, 0.08) 0%, rgba(244, 158, 85, 0.08) 100%);\n  border: 1px solid rgba(107, 64, 146, 0.18);\n  border-radius: 12px;\n  padding: 12px 14px;\n  box-shadow: 0 10px 26px rgba(0, 0, 0, 0.08);\n}\n\n.info-icon {\n  width: 44px;\n  height: 44px;\n  border-radius: 12px;\n  background: #ffffff;\n  color: var(--e-global-color-primary);\n  display: grid;\n  place-items: center;\n  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.08);\n}\n\n.info-title {\n  font-weight: 700;\n  margin: 0 0 4px;\n}\n\n.info-copy {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.info-list {\n  margin: 0;\n  padding-left: 18px;\n  color: #1f2937;\n  display: grid;\n  gap: 4px;\n}\n\n.form-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 14px;\n  position: relative;\n  z-index: 1;\n}\n\n.action-row {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n  margin-top: 6px;\n}\n\n@media (max-width: 768px) {\n  .reconcile-card {\n    padding: 18px;\n  }\n\n  .card-title {\n    font-size: 22px;\n  }\n\n  .info-panel {\n    grid-template-columns: 1fr;\n  }\n\n  .form-grid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
